export const BASE_API = "../../../json";

export * from "./ArquivoApi";
export * from "./AssuntoApi";
export * from "./BancoApi";
export * from "./CiApi";
export * from "./MainApi";
export * from "./NotificacaoApi";
export * from "./PublicacaoApi";
export * from "./SetorApi";
export * from "./UserApi";